export const resolveCommentDOMSelector = (commentId: string) => {
	return `[data-comment-id="${commentId}"]`;
};
